import { gql } from "@apollo/client";

export const CREATE_CMS = gql`
  mutation CreateCmsMutation($input: CreateCmsInput!) {
    createCms(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_CMS = gql`
  mutation UpdateCmsMutation($id: Int!, $input: UpdateCmsInput!) {
    updateCms(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_CMS = gql`
  mutation RemoveCmsMutation($id: Int!) {
    removeCms(id: $id) {
      ok
      error
    }
  }
`;

export const CMS = gql`
  query CmsQuery($id: Int!) {
    cms(id: $id) {
      ok
      error
      result {
        id
        name
      }
    }
  }
`;

export const CMS_LIST = gql`
  query CmsListQuery {
    cmsList {
      ok
      error
      total
      results {
        id
        name
      }
    }
  }
`;
